<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: null,
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<template>
  <b-form-group :id="id">
    <template #label>
      {{ label }}
      <span v-if="isRequired" class="text-danger">* required information </span>
    </template>
    <slot />
  </b-form-group>
</template>
